import React from 'react';

const DokanList = ({ hasBorder, isFeatured, label, value, color = 'text-dark' }) => (
    <div
        className={` flex items-center justify-between border-primary py-3 ${
            hasBorder && 'border-b'
        }`}
    >
        <p className={`${color}`}>{label}</p>{' '}
        <span className={` ${isFeatured ? 'font-bold' : 'font-light'} ${color}`}>{value}</span>
    </div>
);

export default DokanList;
